import { getAllocationUtils } from './utils';
import sortByPrice from './sortByPrice';
import promotedVideoStrip from './promotedVideoStrip';
import { agenciesInListingsGD } from './agenciesInListingsGD';
import { hourlyBannerGuest, hourlyBannerUser } from './hourlyBannerUserAndGuest';
import { adsPlacement } from './adsPlacements';

const experiments = {
    sortByPrice,
    promotedVideoStrip,
    agenciesInListingsGD,
    hourlyBannerGuest,
    hourlyBannerUser,
    adsPlacement,
};

export const clientExperiments = getAllocationUtils(experiments);
